const QuoterPricing = {
  calcularPrecio(e, a, o, r = "premium") {
    if (!e || !a || !o) return this.resultadoVacio();
    // Alias legacy pre-migración ago-2026: llamadas viejas pasan "vinyl".
    if (r === "vinyl") r = "premium";
    const i = window.QUOTER_CONFIG.materiales[r];
    if (!i || !i.habilitado)
      return (
        console.error("Material no disponible:", r),
        this.resultadoVacio()
      );
    const n = e * a,
      s = n * i.costFactor,
      d = this.obtenerMargenPorVolumen(o, r),
      t = s * d,
      c = t * (((window.QUOTER_CONFIG && window.QUOTER_CONFIG.iva) || 1.16) - 1),
      l = t + c,
      u = t * o,
      m = c * o,
      h = l * o;
    return {
      valido: !0,
      dimensiones: { ancho: parseFloat(e), alto: parseFloat(a), area: n },
      cantidad: parseInt(o),
      material: { id: r, nombre: i.nombre },
      costos: {
        costoArea: this.redondear(s),
        factorMargen: d,
        margen: this.redondear(t),
      },
      precios: {
        unitarioSinIva: this.redondear(t),
        unitarioConIva: this.redondear(l),
        subtotal: this.redondear(u),
        iva: this.redondear(m),
        total: this.redondear(h),
      },
    };
  },
  // Tabla de márgenes efectiva para un material: la propia (override del
  // panel, hidratada en materiales[id].margenes) o la global. Espejo del
  // backend (calculator.js: marginsSource).
  margenesDe(materialId) {
    const m = materialId && window.QUOTER_CONFIG.materiales[materialId];
    if (m && Array.isArray(m.margenes) && m.margenes.length > 0)
      return m.margenes;
    return window.QUOTER_CONFIG.margenesPorVolumen;
  },
  obtenerMargenPorVolumen(e, materialId) {
    const a = this.margenesDe(materialId);
    // Espejo de selectMarginTier (backend): por debajo del primer tramo aplica
    // el primer margen (el más alto); el fallback al último solo es hacia arriba.
    if (a.length > 0 && e < a[0].min) return a[0].margen;
    for (let o = 0; o < a.length; o++) {
      const r = a[o];
      if (e >= r.min && e <= r.max) return r.margen;
    }
    return a[a.length - 1].margen;
  },
  calcularTablaDePrecio(e, a, o = "premium") {
    if (o === "vinyl") o = "premium";
    return this.margenesDe(o)
      .map((r) => r.min)
      .map((r) => {
        const i = this.calcularPrecio(e, a, r, o);
        return {
          cantidad: r,
          precioUnitario: i.precios.unitarioConIva,
          precioTotal: i.precios.total,
          valido: i.valido,
        };
      });
  },
  formatearPrecio(e, a = !0) {
    const o = window.QUOTER_CONFIG,
      r = e.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return a ? `${o.simbolo}${r}` : r;
  },
  redondear(e, a = 2) {
    const o = Math.pow(10, a);
    return Math.round(e * o) / o;
  },
  resultadoVacio() {
    return {
      valido: !1,
      dimensiones: { ancho: 0, alto: 0, area: 0 },
      cantidad: 0,
      material: { id: "", nombre: "" },
      costos: { costoBase: 0, margen: 0, multiplicador: 0 },
      precios: {
        unitarioSinIva: 0,
        unitarioConIva: 0,
        subtotal: 0,
        iva: 0,
        total: 0,
      },
    };
  },
};
typeof window < "u" && (window.QuoterPricing = QuoterPricing);
